<template>
	<div v-loading="pageLoading">
		<div v-if="id" class="MB20">
			<el-alert :title="`当前获奖人数：共${formData.awardUserNum || 0}人`" :closable="false"></el-alert>
		</div>
		<el-form :model="formData" :rules="rules" ref="formData" label-position="top" size="medium"
			:disabled="id && formData.awardUserNum > 0 ? true : false">
			<el-row :gutter="40">
				<el-col :xs="24" :sm="12" :xl="8">
					<el-form-item prop="prizeItem" label="奖项：">
						<el-input placeholder="请输入奖项名称" v-model="formData.prizeItem" maxlength="40"
							show-word-limit></el-input>
					</el-form-item>
				</el-col>
				<el-col :xs="24" :sm="12" :xl="8">
					<el-form-item :prop="formData.prizeType == 1 ? 'prizeInfo1' : 'prizeInfo2'">
						<span slot="label">
							奖品：
							<el-radio-group v-model="formData.prizeType">
								<el-radio :label="1">优惠券</el-radio>
								<el-radio :label="2">自定义奖品</el-radio>
							</el-radio-group>
						</span>
						<el-input v-if="formData.prizeType == 1" placeholder="请填写优惠券ID" v-model="formData.prizeInfo1"
							maxlength="6"></el-input>
						<el-input v-else placeholder="请填写奖品名称" v-model="formData.prizeInfo2" maxlength="40"
							show-word-limit></el-input>
					</el-form-item>
				</el-col>
			</el-row>
			<el-row :gutter="40">
				<el-col :xs="24" :xl="16">
					<el-form-item prop="awardInstruction" label="领奖说明：">
						<el-input placeholder="请输入领奖说明" v-model="formData.awardInstruction" maxlength="100"
							show-word-limit></el-input>
					</el-form-item>
					<el-form-item prop="collectInfosType" label="信息收集：">
						<el-radio-group v-model="formData.collectInfosType">
							<el-radio :label="0" border>无需收集信息</el-radio>
							<el-radio :label="1" border>需收集用户信息</el-radio>
						</el-radio-group>
					</el-form-item>
					<el-card v-if="formData.collectInfosType == 1">
						<el-form-item prop="collectInfosType" label="提交截止时间：" v-if="formData.collectInfosType == 1 ">
							<el-date-picker v-model="formData.awardDeadline" type="datetime"
								value-format="yyyy-MM-dd HH:mm:ss" format="yyyy-MM-dd HH:mm:ss" size="medium">
							</el-date-picker>
						</el-form-item>
						<el-row :gutter="40" class="more-btn">
							<el-col :span="12">
								<el-button icon="el-icon-plus" @click="collectInfosMore(1)">添加问题</el-button>
							</el-col>
							<el-col :span="12">
								<el-button icon="el-icon-plus" @click="collectInfosMore(2)">添加选项组</el-button>
							</el-col>
						</el-row>

						<div v-for="(item, index) in formData.collectInfos" :key="index" class="MT20">
							<div v-if="item.question != undefined" class="item">
								<el-form-item :prop="`collectInfos[${index}].question`"
									:rules="[{ required: true, message: `请输入问题` }]" label="问题：">
									<el-input v-model="item.question" maxlength="40" show-word-limit></el-input>
								</el-form-item>
								<el-button type="primary" plain size="medium"
									@click="formData.collectInfos.splice(index, 1)"
									:style="{ marginTop: '24px' }">删除</el-button>
							</div>
							<el-card v-if="item.chooseItems != undefined" shadow="never">
								<div class="el-card-header-box" slot="header">
									<div>选项组</div>
									<el-button type="primary" plain size="medium"
										@click="formData.collectInfos.splice(index, 1)">删除</el-button>
								</div>
								<el-form-item :prop="`collectInfos[${index}].chooseTitle`"
									:rules="[{ required: true, message: `请输入选项组标题` }]" label="标题：">
									<el-input v-model="item.chooseTitle" maxlength="40" show-word-limit></el-input>
								</el-form-item>
								<el-form-item :prop="`collectInfos[${index}].chooseItems`">
									<span slot="label">
										选项：
										<el-button size="mini" type="primary" plain icon="el-icon-plus"
											@click="formData.collectInfos[index].chooseItems.push('')">新增选项</el-button>
									</span>
									<el-row :gutter="40">
										<el-col v-for="(v, i) in formData.collectInfos[index].chooseItems" :key="i"
											:xs="24" :sm="12" class="MB20 item">
											<el-form-item :prop="`collectInfos[${index}].chooseItems[${i}]`"
												:rules="[{ required: true, message: `请输入选项内容` }]" label="">
												<el-input v-model="formData.collectInfos[index].chooseItems[i]"
													maxlength="40" show-word-limit></el-input>
											</el-form-item>
											<el-button v-if="formData.collectInfos[index].chooseItems.length > 1"
												@click="formData.collectInfos[index].chooseItems.splice(i, 1)">删除</el-button>
										</el-col>
									</el-row>
								</el-form-item>
							</el-card>
						</div>
					</el-card>
				</el-col>
			</el-row>
			<el-row :gutter="40">
				<el-col :xs="24" :xl="16">
					<el-form-item label="自动发奖：">
						<span slot="label">自动发奖：<el-switch v-model="formData.autoSendReward" :active-value="1"
								:inactive-value="0"></el-switch></span>
						<el-card v-if="formData.autoSendReward == 1 ">
							<el-form-item prop="collectInfosType" label="自动发放排序：">
								<el-select v-model="formData.autoSendSort" placeholder="请选择售票模式" size="medium"
									style="width: 50%;">
									<el-option :value="3" label="综合排序(与排行榜顺序一致)"></el-option>
									<el-option :value="1" label="优先秀动统计UV高的"></el-option>
									<el-option :value="2" label="优先秀动统计PV高的"></el-option>
									<el-option :value="4" label="优先百度UV高的"></el-option>
									<el-option :value="5" label="优先百度pv高的"></el-option>
								</el-select>
							</el-form-item>
							<el-form-item prop="collectInfosType" label="自动发放排名：" class="MT10">
								<p>从
									<el-input-number v-model="formData.autoSendStartRank" :precision="0"
										controls-position="right" :max="10000"></el-input-number>
									名至
									<el-input-number v-model="formData.autoSendEndRank" :precision="0"
										controls-position="right" :max="10000"></el-input-number>
									名
								</p>
							</el-form-item>
							<el-form-item prop="collectInfosType" label="自动发放时间：" class="MT10" style="width: 50%;">
								<el-date-picker v-model="formData.autoSendTime" type="datetime"
									value-format="yyyy-MM-dd HH:mm:ss" format="yyyy-MM-dd HH:mm:ss" size="medium">
								</el-date-picker>
							</el-form-item>
						</el-card>
					</el-form-item>
				</el-col>
			</el-row>
			<div class="MT30">
				<el-button @click="goBack" :disabled="false">返回</el-button>
				<el-button type="primary" @click="onSubmit" :loading="btnLoading">确认提交</el-button>
			</div>
		</el-form>
	</div>
</template>
<script>
	export default {
		props: {
			shareActivityId: {
				type: [Number, String],
				default: ''
			},
			id: {
				type: [Number, String],
				default: ''
			},

		},
		data() {
			return {
				formData: {
					awardInstruction: "", //领奖说明
					collectInfosType: 0, //是否收集信息
					collectInfos: [], //信息收集	
					prizeItem: "", //奖项
					prizeInfo: "", //奖品内容
					prizeInfo1: "", //优惠券	
					prizeInfo2: "", //自定义奖品		
					prizeType: 1, //奖品类型 1：优惠券 2：自定义奖品
					autoSendReward: 0,
					autoSendSort: 3,
					autoSendTime: this.$route.query.time,
					autoSendStartRank: undefined,
					autoSendEndRank: undefined
				},
				rules: {
					prizeItem: [{
						required: true,
						message: "请填写奖项名称"
					}],
					prizeInfo1: [{
						required: true,
						message: "请填写优惠券ID"
					}],
					prizeInfo2: [{
						required: true,
						message: "请填写奖品名称"
					}],
					// collectInfos: [{ required: true, message: "请填写问题或选项组" }],
				},
				btnLoading: false,
				pageLoading: false,
				redirect: this.$route.query.redirect ||
					`/promotion/shareActivity/award/list?shareActivityId=${this.shareActivityId}&time=${this.$route.query.time}`,
			}
		},

		mounted() {
			if (this.id) {
				this.getData();
			}
		},
		methods: {
			// 获取详情
			getData() {

				this.pageLoading = true;
				this.$request({
					url: "/share/activity/prize/info",
					method: "POST",
					params: {
						prizeId: this.id,
						shareActivityId: this.shareActivityId
					},
				}).then((res) => {
					//处理成功回调
					const {
						state,
						msg,
						result
					} = res.data;
					if (state && state == 1 && result) {
						this.formData = {
							...this.formData,
							...result,
							collectInfosType: result.collectInfos && result.collectInfos.length > 0 ? 1 : 0,
							prizeInfo1: result.prizeType == 1 ? result?.prizeInfo : "",
							prizeInfo2: result.prizeType == 2 ? result?.prizeInfo : "",
						}
					} else {
						return this.$message.error(msg || "获取详情失败");
					}
				}).finally(() => {
					this.pageLoading = false;
				});
			},
			handleMin(value) {
				let num = parseInt(value.replace(/\D/g, ''), 10);
				if (isNaN(num)) {
					num = 0
				}
				//限制在0-10000
				if (num < 0) num = 0;
				if (num > 100) num = 10000;
				this.formData.autoSendStartRank = num;
				//联动:如果最大值小于当前最小值，则调整最大值
				if (this.formData.autoSendEndRank < num) {
					this.formData.autoSendEndRank = num;
				}
			},
			handleMax(value) {
				let num = parseInt(value.replace(/\D/g, ''), 10);
				if (isNaN(num)) {
					num = 0
				}
				//限制在0-10000
				if (num < 0) num = 0;
				if (num > 100) num = 10000;
				this.formData.autoSendStartRank = num;
				//联动:如果最大值小于当前最小值，则调整最大值
				if (this.formData.autoSendStartRank < num) {
					this.formData.autoSendStartRank = num;
				}
			},
			//表单提交
			onSubmit() {
				this.$refs["formData"].validate((valid) => {
					if (valid) {
						const _collectInfos = this.formData.collectInfosType == 0 ? [] : this.formData.collectInfos
						if (this.formData.collectInfosType == 1 && _collectInfos.length == 0) {
							return this.$message.error('请填写问题或选项组')
						}
						if (this.formData.autoSendReward == 1 && (!this.formData.autoSendStartRank || !this
								.formData.autoSendEndRank)) {
							return this.$message.error('请填写自动发放排名')
						}
						if (this.formData.autoSendReward == 1 && (this.formData.autoSendStartRank > this
								.formData.autoSendEndRank)) {
							return this.$message.error('自动发放排名开始名次必须小于结束名次')
						}
						this.btnLoading = true;
						this.$request({
								url: "/share/activity/prize/edit",
								method: "POST",
								data: {
									...this.formData,
									id: this.id || "",
									shareActivityId: this.shareActivityId || "",
									prizeInfo: this.formData.prizeType == 1 ? this.formData.prizeInfo1 : this
										.formData.prizeInfo2,
									collectInfos: _collectInfos
								},
							})
							.then((res) => {
								//处理成功回调
								const {
									state,
									msg
								} = res.data;
								if (state && state == 1) {
									this.goBack();
								} else {
									return this.$message.error(msg || "操作失败");
								}
							})
							.finally(() => {
								this.btnLoading = false;
							});
					}
				})
			},
			collectInfosMore(type) {
				if (type == 1) {
					this.formData.collectInfos.push({
						question: ""
					})
				} else {
					this.formData.collectInfos.push({
						chooseTitle: '',
						chooseItems: [''],
					})
				}
			},
			//返回
			goBack() {
				this.$router.push({
					path: this.redirect,
				});
			},
		}
	}
</script>

<style lang="scss" scoped>
	::v-deep .el-card__header {
		line-height: normal;
	}

	.more-btn {
		.el-button {
			width: 100%;
			border-style: dashed;
		}
	}

	.el-card-header-box {
		display: flex;
		align-items: center;
		justify-content: space-between;
	}

	.item {
		display: flex;
		align-items: center;

		.el-form-item {
			flex: 1;
			margin-right: 10px;
		}
	}
</style>